export const CURRENT_CLIENT_VERSION = '2.0'
